import React from 'react';

import gogglesBackView from '../../../main/assets/images/fpvonepilot/fpv-one-pilot-back-view.webp';

export const CrispAndClear = () => {
  return (
    <section className="fpv-pilot-crisp-container">
      <div className="fpv-pilot-crisp-bg" />
      <div className="fpv-pilot-crisp-section">
        <div className="fpv-pilot-crisp-image">
          <img
            src={gogglesBackView}
            alt="Device Back View"
            className="fpv-pilot-crisp-product"
          />
        </div>
        <div className="fpv-pilot-crisp-text">
          <div className="fpv-pilot-crisp-titles">
            <h3 className="fpv-pilot-crisp-subtitle">Image Quality</h3>
            <h2 className="fpv-pilot-crisp-title">
              <span className="fpv-pilot-crisp-title-span">Crisp and </span>
              <span className="fpv-pilot-crisp-title-span">clear</span>
            </h2>
          </div>
          <p className="fpv-pilot-crisp-description">
            Enjoy the thrill of immersive flying with high end OLED displays
          </p>
        </div>
      </div>
    </section>
  );
};
